import { TAG_STATUS } from '@evinced-private/ui-common';

import { STATUS_MAPPING, TREND_TAG_KIND } from '../constants';
import { AccessibilityStatus, StatusTag, TrendDirection, TrendTag } from '../types';

import { AccessibilityMetric } from './accessibilityHelpers';

export const getStatusTag = (status: AccessibilityStatus): StatusTag => STATUS_MAPPING[status];

export const getNAStatusTag = (): StatusTag => ({
	status: TAG_STATUS.INFO,
	text: 'N/A'
});

const formatNumber = (value: number): string => new Intl.NumberFormat('en-US').format(value);

export const getTrendTag = (metric: AccessibilityMetric): TrendTag => {
	if (metric.value === '0') {
		return { kind: TREND_TAG_KIND.INFO, text: 'N/A' };
	}
	if (metric.trend.percentage === 0) {
		return { kind: TREND_TAG_KIND.INFO, text: '+0%' };
	}
	const isUp = metric.trend.direction === TrendDirection.UP;
	// UP = more issues = bad (red, no success); DOWN = fewer issues = good (green, success)
	// Positive liftNumber → EvLift shows ↑; negative → ↓
	return {
		kind: TREND_TAG_KIND.LIFT,
		liftNumber: isUp ? metric.trend.percentage : -metric.trend.percentage,
		success: !isUp
	};
};

export const getTrendAriaLabel = (metric: AccessibilityMetric): string => {
	if (metric.value === '0') {
		return 'No data available';
	}
	return `Trend: ${metric.trend.direction} by ${formatNumber(metric.trend.percentage)}%`;
};
